<template lang="pug">
#about.about.page
  .about-intro
    .content
      .wrap
        header.header
          h1.title About
  .about
    .wrap
      .about__intro(ref="about-intro")
        p I'm building <a class="ai" href="https://pumpgtm.com/">PumpGTM</a> in San Francisco, an AI agent that finds the buyers who are ready to talk and runs your outreach. We're backed by Y Combinator.

        p I also <a href="https://nmn.gl/blog" class="ayom" style="text-decoration: underline">write about AI often</a>. My articles received over four million views in 2025, with coverage in The New York Times, Futurism and Inc. Magazine.

        p I started programming at <strong class="dyeus">13</strong> and have since built apps used by millions of people.
</template>

<script>
export default {
  name: 'About'
}
</script>

<style lang="stylus" scoped>
@import '~@/styl/_variables'

.page
  padding 3em 0 1em
  background-color $color--hero-bg
  background-image radial-gradient(circle at 25%, $color--hero-bg 10%, $color--hero-bg--dark)
  color darken($color--hero-text, 10%)
  font-weight 300

.about
  .header
    display: flex
    width: 100%
    justify-content: space-between
    align-items: center
    margin 0 0 2em

  .title
    font-size: 4em
    font-weight: bold
    color: $color--hero-title
    margin: 0

  .subtitle
    font-style: italic
    font-size: 1.5em
    font-weight: 300
    color: $color--hero-subtitle

  .wrap
    display: flex
    justify-content: space-between

gradient-text($gradient, $bg = 'light') {
  @supports (mix-blend-mode: lighten) {
    display: inline-block;
    position: relative;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: unquote($gradient);
      pointer-events: none;
    }

    if ($bg == 'light') {
      color: #000;
      background: #fff;
      mix-blend-mode: multiply;

      &::before {
        mix-blend-mode: screen;
      }
    } else {
      color: #fff;
      background: #000;
      mix-blend-mode: lighten;

      &::before {
        mix-blend-mode: multiply;
      }
    }
  }
}

.about {
  .ayom {
    font-weight: 500;
    text-decoration: none;
    gradient-text('linear-gradient(to right, rgba(24,138,141,1) 11.2%, rgba(96,221,142,1))', 'dark');
  }

  .dyeus {
    font-weight: 500;
    gradient-text('linear-gradient(to left, rgba(246,191,13,1) 0%, rgb(255 104 104)  90%)', 'dark');
  }

  .ai {
    font-weight: 500;
    gradient-text('linear-gradient(to right, #177800, #82b000)', 'dark');
  }
}

.about__intro {
  p:first-child {
    margin-top: 0;
  }
  font-size: 1.5em;
  padding: 0 0 3em;
}

@media (max-width: 67.5em) {
  .about {
    .header {
      flex-direction: column;
      margin: 0 0 2em;
      align-items: start !important;
    }

    .title {
      margin: 0;
    }

    .subtitle {
      font-size: 1.375em;
    }
  }
}

@media (max-width: 60em) {
  .subtitle {
    font-size: 1.125em;
  }

  .about {
    font-size: 0.875em;
    .wrap {
      width: 90%
    }
  }
}

@media (max-width: 50em) {
  .about__history, .about__intro {
    font-size 1.25em
  }

  .title {
    font-size: 3em;
  }

  .subtitle {
    font-size: 1em;
  }
}

@media (max-width: 37.5em) {
  .about > .wrap {
    flex-direction column
  }
}

@media (max-width: 32.5em) {
  .about .title {
    font-size: 2.5em;
    margin: 1em 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About/About.vue